module.exports = __webpack_public_path__ + "img/composite4.6e59deb5.png";